import React from "react";
import Skeleton from "react-loading-skeleton";

function MediaProfileCardSkeleton() {
  return (
    <div className="card h-100 skeleton-card animated faster fadeIn">
      <div className="card-body d-flex flex-column">
        <div className="d-flex align-items-start gap-2 mb-2">
          <Skeleton circle height={60} width={60} />
          <div className="flex-fill">
            <Skeleton height={15} width="80%" />
            <Skeleton height={12} width="55%" />
          </div>
        </div>

        <div className="smaller mb-2">
          <Skeleton height={12} width="35%" />
          <Skeleton height={12} width="60%" />
        </div>

        <div className="smallest mb-2">
          <Skeleton height={8} width="90%" />
          <Skeleton height={8} width="75%" />
        </div>

        <div className="mt-auto">
          <Skeleton height={25} width="100%" />
        </div>
      </div>
    </div>
  );
}

export default MediaProfileCardSkeleton;
